<template>
  <div
    v-if="show"
    class="selection-banner">
    <v-icon
      class="mr-2"
      color="warning">
      mdi-alert-circle
    </v-icon>
    <span class="banner-text">
      <strong>{{ totalSelected }}</strong> {{ itemLabel }} selected
      <template v-if="hasNonVisible">
        (<strong>{{ visibleCount }}</strong> visible,
        <strong>{{ nonVisibleCount }}</strong> not currently shown)
      </template>
    </span>
    <v-spacer />
    <v-btn
      variant="text"
      size="small"
      @click="emit('clear')">
      Clear
    </v-btn>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  totalSelected: {
    type: Number,
    default: 0,
  },
  visibleCount: {
    type: Number,
    default: 0,
  },
  nonVisibleCount: {
    type: Number,
    default: 0,
  },
  itemType: {
    type: String,
    default: 'items',
  },
});

const emit = defineEmits(['clear']);

const show = computed(() => props.totalSelected > 0 && props.nonVisibleCount > 0);

const hasNonVisible = computed(() => props.nonVisibleCount > 0);

const itemLabel = computed(() => {
  return props.totalSelected === 1
    ? props.itemType.replace(/s$/, '')
    : props.itemType;
});
</script>

<style scoped>
.selection-banner {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background-color: rgba(255, 193, 7, 0.15);
  border: 1px solid rgba(255, 193, 7, 0.4);
  border-radius: 4px;
  margin: 0 20px 12px 20px;
}

.banner-text {
  font-size: 0.875rem;
  color: var(--text);
}
</style>
